<ng-container *transloco="let t; read: 'DISH_DETAILS_COMPONENT'">
  <ion-content *ngIf="dish" [scrollEvents]="dish.mainImageUrl" (ionScroll)="onScroll($event)">
    <div class="dish-details-inner" *ngLet="showDataInHeader$ | async as showDataInHeader">
      <app-dish-quantity-picker *ngIf="showQuantityPicker" [dish]="dish">
        <div class="mt-12"></div>
        <app-cart-button (click)="openCartModal()"></app-cart-button>
      </app-dish-quantity-picker>
      <div class="dish-toolbar-header" [class.has-long-title]="titleEl?.nativeElement.offsetHeight > 26" #toolbar [class.show-title]="showDataInHeader">
        <ion-button (click)="dismissModal()" fill="none" color="secondary">
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
        <h1 #title>{{ dish!.label }}</h1>
        <div class="right">
          <ng-container *ngIf="dish.imageUrls.length === 0 || showDataInHeader">
            <app-like-counter
              class="use-current-theme"
              [hideTotal]="true"
              *ngIf="dishLikes"
              [likes]="dishLikes"
              (likeClick)="onLikeClick($event, dishLikes.canBeNotified)"
            ></app-like-counter>
          </ng-container>
        </div>
      </div>
      <div class="dish-img-container" *ngIf="dish.imageUrls.length > 0">
        <!-- 1 image - static image -->
        <img class="dish-img" *ngIf="dish.imageUrls.length === 1" [src]="dish.imageUrls" />

        <!-- 2+ image - swiper -->
        <swiper *ngIf="dish.imageUrls.length >= 2" [pagination]="{ dynamicBullets: true, dynamicMainBullets: 3 }" [centeredSlides]="true">
          <ng-container *ngFor="let imageUrl of dish.imageUrls">
            <ng-template swiperSlide>
              <img class="dish-img" [src]="imageUrl" />
            </ng-template>
          </ng-container>
        </swiper>

        <app-like-counter
          *ngIf="dishLikes"
          [likes]="dishLikes"
          (likeClick)="onLikeClick($event, dishLikes.canBeNotified)"
          [class.with-slider]="dish.imageUrls.length >= 2"
        ></app-like-counter>
      </div>
      <div
        class="dish-details-container"
        [class.has-long-title]="titleEl?.nativeElement.offsetHeight > 26"
        [class.no-image-margin]="!dish.mainImageUrl && showDataInHeader"
      >
        <h2 [class.hide]="showDataInHeader" *ngIf="dish.mainImageUrl" class="text-start mb-16">
          {{ dish!.label }}
        </h2>

        <div *ngIf="dish.imageUrls.length === 0 && dishLikes && dishLikes.totalLikes > 0" class="dish-information-container">
          <ion-icon class="mr-8" name="heart"></ion-icon>
          <div>{{ dishLikes.totalLikes }} {{ t('FAVORITES', { count: dishLikes.totalLikes }) }}</div>
        </div>

        @if (dish.description) {
          <app-dish-details-category [title]="t('DESCRIPTION')">
            <div>{{ dish.description }}</div>
          </app-dish-details-category>
        }
        <app-pork-free *ngIf="dish.isPorkFree"></app-pork-free>
        <app-has-pork *ngIf="dish.hasPork"></app-has-pork>
        <app-veggie *ngIf="dish.isVeggie"></app-veggie>
        <div *ngIf="dish.standName" class="dish-information-container fade-in">
          <ion-icon src="/assets/svg/dish/informations/stand.svg"></ion-icon>
          <div>{{ dish.standName }}</div>
        </div>

        <app-dish-details-category
          *ngIf="!!dish.labels.length"
          [title]="t('LABEL', { count: dish.labels.length })"
          [hasModalLink]="true"
          (openModal)="onLabelsClick(dish.labels!)"
        >
          <app-dish-details-typologies [typologies]="dish.labels"></app-dish-details-typologies>
        </app-dish-details-category>

        <app-dish-details-category
          *ngIf="!!dish.markers!.length"
          [title]="t('MARKER', { count: dish.markers.length })"
          [hasModalLink]="true"
          (openModal)="onMarkersClick(dish.markers!)"
        >
          <app-dish-details-typologies [typologies]="dish.markers"></app-dish-details-typologies>
        </app-dish-details-category>

        <app-dish-details-category *ngIf="!!dish.partners!.length" [title]="t('PARTNER', { count: dish.partners.length })">
          <app-dish-details-typologies [typologies]="dish.partners"></app-dish-details-typologies>
        </app-dish-details-category>

        <app-dish-details-category *ngIf="dish.nutriscore" [title]="t('NUTRISCORE')" [hasModalLink]="true" (openModal)="onNutriscoreClick()">
          <div class="flex items-center">
            <app-nutriscore [nutriscore]="dish.nutriscore"></app-nutriscore>
            <div [ngSwitch]="dish.nutriscore">
              <div *ngSwitchCase="'A'">{{ t('A_TO_PREFER') }}</div>
              <div *ngSwitchCase="'E'">{{ t('E_TO_LIMIT') }}</div>
            </div>
          </div>
        </app-dish-details-category>

        <app-dish-details-category *ngIf="dish.carbonScore" [title]="t('CARBONSCORE')" [hasModalLink]="true" (openModal)="onCarbonscoreClick()">
          <div class="flex items-center" *transloco="let t; read: 'CARBONSCORE_COMPONENT'">
            <app-carbon-score [carbonScore]="dish.carbonScore"></app-carbon-score>
            <div>
              <div class="mb-8">{{ t('CARBONSCORE_' + dish.carbonScore) }}</div>
              <div class="carbonscore-description">{{ t('CARBONSCORE_DESCRIPTION') }}</div>
            </div>
          </div>
        </app-dish-details-category>

        <app-dish-details-category
          *ngIf="dish.greenScore"
          [title]="t('GREENSCORE')"
          class="greenscore-category"
          [hasModalLink]="true"
          (openModal)="onGreenscoreClick()"
        >
          <div class="flex items-center" *transloco="let t; read: 'GREENSCORE_COMPONENT'">
            <app-green-score [greenScore]="dish.greenScore" [showLabel]="false"></app-green-score>
            <div>
              <div class="greenscore-name">{{ t('GREENSCORE_NAME') }}</div>
              <div class="greenscore-description">{{ t('GREENSCORE_' + dish.greenScore) }}</div>
            </div>
          </div>
        </app-dish-details-category>

        <app-dish-details-category *ngIf="!!dish.ingredients!.length" [title]="t('INGREDIENT', { count: dish.ingredients.length })">
          <div>{{ ingredients }}</div>
        </app-dish-details-category>

        <app-dish-details-category *ngIf="dish.calories" [title]="t('ENERGETIC_VALUE')">
          <div class="flex">
            <div class="progress-wrapper">
              <div class="progress-wrapper-text">
                <div class="calories-count">{{ dish.calories.amount! }}</div>
                <div class="calories-unit">{{ t('CALORIES') }}</div>
              </div>
              <round-progress
                [current]="dish.calories.percentageDailyIntake!"
                [max]="100"
                [clockwise]="true"
                [responsive]="true"
                [radius]="125"
                [stroke]="15"
                [rounded]="true"
                [duration]="100"
                [animation]="'easeInOutQuart'"
              >
              </round-progress>
            </div>
            <div class="spacer">
              {{ t('CALORIE_INFORMATION', { percentage: dish.calories.percentageDailyIntake! }) }}
            </div>
          </div>
        </app-dish-details-category>

        <app-dish-details-category *ngIf="dish.nutritionnalValues.length" [title]="t('NUTRITIONAL_VALUES')">
          <app-nutritionnal-values [nutritionnalValues]="dish.nutritionnalValues"> </app-nutritionnal-values>
        </app-dish-details-category>

        <app-dish-details-category
          *ngIf="dish.allergens.length"
          [title]="t('ALLERGEN', { count: dish.allergens.length })"
          [hasModalLink]="true"
          (openModal)="onAllergensClick()"
        >
          <app-allergens [allergens]="dish.allergens" [userAllergens]="userAllergens"></app-allergens>
        </app-dish-details-category>

        <div class="mt-24"></div>
      </div>
    </div>
  </ion-content>
</ng-container>
